import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import { OrgAccessRequest } from "../../generated/core-api";

export function useRevokeOrgAccess() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: OrgAccessRequest) => api.revokeOrgAccess(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-admin", "users"] });
    },
  });
}
